/* eslint-disable max-len */
import * as yup from 'yup';
import moment from 'moment';

import i18n from '../../../i18n';
import { formFields } from '../../../constants/formFields';
import { PASS_REGEX } from '../../../utils/index';

import { GLN_VALIDATION } from './commonValidations';


const fildsSpecifications
  = {
    [formFields.USERNAME]: yup
      .string().max(255)
      .when(`${formFields.USERNAME}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.usernameRequired')) }),
    // -----------------------------------
    [formFields.PASSWORD]: yup
      .string()
      .when(`${formFields.PASSWORD}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) })
      .matches(PASS_REGEX, i18n.t('ERR.InvalidPasswordFormat')),
    // -----------------------------------
    [formFields.REPEAT_PASSWORD]: yup
      .string().oneOf([ yup.ref(formFields.NEW_PASSWORD), null ], i18n.t('ERR.passwordMismatch'))
      .when(`${formFields.REPEAT_PASSWORD}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.OLD_PASSWORD]: yup
      .string()
      .when(`${formFields.OLD_PASSWORD}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.NEW_PASSWORD]: yup
      .string()
      .when(`${formFields.NEW_PASSWORD}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) })
      .matches(PASS_REGEX, i18n.t('ERR.InvalidPasswordFormat'))
      .notOneOf([ yup.ref(formFields.OLD_PASSWORD) ], i18n.t('ERR.NewOldPasswordMismatch')),
    // -----------------------------------
    [formFields.EMAIL]: yup
      .string()
      .email(i18n.t('ERR.invalidEmail'))
      .max(255)
      .when(`${formFields.EMAIL}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.OLD_EMAIL]: yup
      .string()
      .email(i18n.t('ERR.invalidEmail'))
      .max(255)
      .when(`${formFields.OLD_EMAIL}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),

    // -----------------------------------
    [formFields.NEW_EMAIL]: yup
      .string()
      .email(i18n.t('ERR.invalidEmail'))
      .max(255)
      .when(`${formFields.NEW_EMAIL}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.REPEAT_EMAIL]: yup
      .string()
      .email(i18n.t('ERR.invalidEmail'))
      .max(255)
      .when(`${formFields.REPEAT_EMAIL}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.STAKEHOLDER_EMAIL]: yup
      .string()
      .email(i18n.t('ERR.invalidEmail'))
      .max(255)
      .when(`${formFields.STAKEHOLDER_EMAIL}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.ESTABLISHMENT_EMAIL]: yup
      .string()
      .email(i18n.t('ERR.invalidEmail'))
      .max(255)
      .when(`${formFields.ESTABLISHMENT_EMAIL}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.SENDER_MAIL_ADDRESS]: yup
      .string()
      .email(i18n.t('ERR.invalidEmail'))
      .max(255)
      .when(`${formFields.SENDER_MAIL_ADDRESS}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.ESTABLISHMENT]: yup
      .string()
      .max(255)
      .when(`${formFields.ESTABLISHMENT}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.ESTABLISHMENT_AR]: yup
      .string()
      .max(255)
      .when(`${formFields.ESTABLISHMENT_AR}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.ESTABLISHMENT_EN]: yup
      .string()
      .max(255)
      .when(`${formFields.ESTABLISHMENT_EN}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.ESTABLISHMENT_TYPE]: yup
      .string()
      .when(`${formFields.ESTABLISHMENT_TYPE}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.PHONE]: yup
      .string().nullable()
      .matches(/\d$/, i18n.t('ERR.invalidMobile'))
      .matches(/^(\d{10,14})$/, i18n.t('ERR.invalidMobileStructure'))
    // .matches(/^(009665|9665|\+9665|05|5)([0-9]{8})$/, i18n.t('ERR.invalidMobile'))
      .max(14)
      .when(`${formFields.PHONE}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.MOBILE]: yup
      .string()
      .matches(/\d$/, i18n.t('ERR.invalidMobile'))
    // .matches(/^(009665|9665|\+9665|05|5)([0-9]{8})$/, i18n.t('ERR.invalidMobile'))
      .max(14)
      .when(`${formFields.MOBILE}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.FAX]: yup
      .string()
      .matches(/^\d{10,}$/, i18n.t('ERR.invalidFax'))
      .max(14)
      .when(`${formFields.FAX}_Required`, { is: true, then: yup.string().matches(/^\d{10,}$/, i18n.t('ERR.invalidFax')).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.ADDRESS_AR]: yup
      .string()
      .max(400)
      .when(`${formFields.ADDRESS_AR}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.ADDRESS_EN]: yup
      .string()
      .max(400)
      .when(`${formFields.ADDRESS_EN}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.STAKEHOLDER_ADDRESS_EN]: yup
      .string()
      .max(400)
      .when(`${formFields.STAKEHOLDER_ADDRESS_EN}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.STAKEHOLDER_ADDRESS_AR]: yup
      .string()
      .max(400)
      .when(`${formFields.STAKEHOLDER_ADDRESS_AR}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.REGION]: yup
      .string().nullable()
      .when(`${formFields.REGION}_Required`, { is: true, then: yup.string().matches(/^(?!.*(-1))/, i18n.t('ERR.fieldRequired')).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.CITY]: yup
      .string().nullable()
      .when(`${formFields.CITY}_Required`, { is: true, then: yup.string().matches(/^(?!.*(-1))/, i18n.t('ERR.fieldRequired')).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.DISTRICT]: yup
      .string()
      .max(150)
      .when(`${formFields.DISTRICT}_Required`, { is: true, then: yup.string().max(150).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.CONTACT_PERSON_F_NAME]: yup
      .string()
      .max(150)
      .when(`${formFields.CONTACT_PERSON_F_NAME}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.CONTACT_PERSON_S_NAME]: yup
      .string()
      .max(150)
      .when(`${formFields.CONTACT_PERSON_S_NAME}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.CONTACT_PERSON_MOBILE]: yup
      .string()
      .matches(/\d$/, i18n.t('ERR.invalidMobile'))
      .matches(/^(\d{10,14})$/, i18n.t('ERR.invalidMobileStructure'))
      .when(`${formFields.CONTACT_PERSON_MOBILE}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.RESPONSIBLE_PERSON_F_NAME]: yup
      .string()
      .max(100)
      .when(`${formFields.RESPONSIBLE_PERSON_F_NAME}_Required`, { is: true, then: yup.string().max(100).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.RESPONSIBLE_PERSON_NAME]: yup
      .string()
      .max(150)
      .when(`${formFields.RESPONSIBLE_PERSON_NAME}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.RESPONSIBLE_PERSON_S_NAME]: yup
      .string()
      .max(100)
      .when(`${formFields.RESPONSIBLE_PERSON_S_NAME}_Required`, { is: true, then: yup.string().max(100).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.RESPONSIBLE_PERSON_PHONE]: yup
      .string()
      .matches(/^(\d{10,14})$/, i18n.t('ERR.invalidMobileStructure'))
      .when(`${formFields.RESPONSIBLE_PERSON_PHONE}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.STAKEHOLDER_NAME_AR]: yup
      .string()
      .max(255)
      .when(`${formFields.STAKEHOLDER_NAME_AR}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.STAKEHOLDER_NAME_EN]: yup
      .string()
      .max(255)
      .when(`${formFields.STAKEHOLDER_NAME_EN}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.STAKEHOLDER_NAME]: yup
      .string()
      .max(255)
      .when(`${formFields.STAKEHOLDER_NAME}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.PRODUCT_CONTROL]: yup
      .string()
      .when(`${formFields.PRODUCT_CONTROL}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.STAKEHOLDER_TYPE]: yup
      .string().nullable()
      .when(`${formFields.STAKEHOLDER_TYPE}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.LICENSE_NUMBER]: yup
      .string()
      .max(50)
      .nullable()
      .when(`${formFields.LICENSE_NUMBER}_Required`, { is: true, then: yup.string().max(50).nullable()
        .required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.LATITUDE]: yup
      .string()
      .matches(/^(\+|-)?(?:90(?:(?:\.0{1,7})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,7})?))$/,
        i18n.t('ERR.invalidLatitude'))
      .when(`${formFields.LATITUDE}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.LONGITUDE]: yup
      .string()
      .matches(/^(\+|-)?(?:180(?:(?:\.0{1,7})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,7})?))$/
        , i18n.t('ERR.invalidLongitude'))
      .when(`${formFields.LONGITUDE}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.DRUG_NAME]: yup
      .string().max(400)
      .when(`${formFields.DRUG_NAME}_Required`, { is: true, then: yup.string().max(400).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.REGISTRATION_NUMBER]: yup
      .string().max(50)
      .when(`${formFields.REGISTRATION_NUMBER}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.GTIN]: yup
      .string()
      .matches(/^-?[0-9]*(\.[0-9]*)?$/, i18n.t('ERR.notNumber'))
      .min(14)
      .max(14)
      .when(`${formFields.GTIN}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.STATUS]: yup
      .string()
      .when(`${formFields.STATUS}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.STAKEHOLDER]: yup
      .mixed()
      .nullable()
      .when(`${formFields.STAKEHOLDER}_Required`, { is: true, then: yup.mixed().nullable().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.GENERIC_NAME]: yup
      .string().max(400)
      .when(`${formFields.GENERIC_NAME}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.GENERIC_NAME_AR]: yup
      .string().max(400)
      .when(`${formFields.GENERIC_NAME_AR}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.GENERIC_NAME_ITEM]: yup
      .mixed()
      .when(`${formFields.GENERIC_NAME_ITEM}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.REGISTERED]: yup
      .string().nullable()
      .when(`${formFields.REGISTERED}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.REVIEWED]: yup
      .string()
      .nullable()
      .when(`${formFields.REVIEWED}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.DOMAIN_ID]: yup
      .mixed()
      .when(`${formFields.DOMAIN_ID}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.IS_EXPORTABLE]: yup
      .mixed()
      .when(`${formFields.IS_EXPORTABLE}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.IS_IMPORTTABLE]: yup
      .mixed()
      .when(`${formFields.IS_IMPORTTABLE}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.IS_ONLY_HOSPITAL]: yup
      .mixed()
      .when(`${formFields.IS_ONLY_HOSPITAL}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.LEGAL_STATUS]: yup.mixed()
      .when(`${formFields.LEGAL_STATUS}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.AUTHORIZATION_STATUS]: yup
      .mixed()
      .when(`${formFields.AUTHORIZATION_STATUS}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.PRODUCT_CONTROL]: yup
      .mixed()
      .when(`${formFields.PRODUCT_CONTROL}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.MARKETING_STATUS]: yup.mixed()
      .when(`${formFields.MARKETING_STATUS}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.PRODUCT_LEVEL]: yup
      .mixed()
      .when(`${formFields.PRODUCT_LEVEL}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.UNIT_LEVEL]: yup
      .number().nullable()
      .when(`${formFields.UNIT_LEVEL}_Required`, { is: true, then: yup.number().nullable().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.STAKEHOLDER_LIST]: yup
      .mixed()
      .when(`${formFields.STAKEHOLDER_LIST}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.MANAGEMENT_USERNAME]: yup
      .string().max(30)
      .when(`${formFields.MANAGEMENT_USERNAME}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.FIRST_NAME]: yup
      .string().max(100)
      .when(`${formFields.FIRST_NAME}_Required`, { is: true, then: yup.string().max(100).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.SUR_NAME]: yup
      .string().max(100)
      .when(`${formFields.SUR_NAME}_Required`, { is: true, then: yup.string().max(100).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.COMMENT]: yup
      .string().nullable().max(400)
      .when(`${formFields.COMMENT}_Required`, { is: true, then: yup.string().nullable().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.IS_DELETED]: yup
      .bool()
      .typeError(i18n.t('ERR.fieldRequired'))
      .when(`${formFields.IS_DELETED}_Required`, { is: true, then: yup.bool().typeError(i18n.t('ERR.fieldRequired')).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.INVESTIGATION_RESULT]: yup
      .number()
      .typeError(i18n.t('ERR.fieldRequired'))
      .when(`${formFields.INVESTIGATION_RESULT}_Required`, { is: true, then: yup.number().typeError(i18n.t('ERR.fieldRequired')).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.GLN]: GLN_VALIDATION,
    // -----------------------------------
    [formFields.SOURCE_GLN]: GLN_VALIDATION,
    // -----------------------------------
    [formFields.DESTINATION_GLN]: GLN_VALIDATION,
    // -----------------------------------
    [formFields.STAKEHOLDER_GLN]: GLN_VALIDATION,
    // -----------------------------------
    // [formFields.TO_STAKEHOLDER]: GLN_VALIDATION,
    [formFields.TO_STAKEHOLDER]: yup
      .mixed()
      .when(`${formFields.TO_STAKEHOLDER}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    // -----------------------------------
    [formFields.START_DATE]: yup
      .mixed()
      .when(`${formFields.START_DATE}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.END_DATE]: yup
      .string().nullable().test('endDate-after-startDate', i18n.t('ERR.startDateExceedingEndDate'),
        (value, { parent }) => (
          !value
        || !parent[formFields.START_DATE]
        || moment(value, 'DD-MM-YYYY') >= moment(parent[formFields.START_DATE], 'DD-MM-YYYY')))
      .when(`${formFields.END_DATE}_Required`, { is: true, then: yup.string().nullable().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.EXPIRY_DATE]: yup
      .mixed()
      .when(`${formFields.EXPIRY_DATE}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.MANUFACTURER_DATE]: yup
      .mixed()
      .when(`${formFields.MANUFACTURER_DATE}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.PRODUCT_LEVEL]:
    yup.mixed()
      .when(`${formFields.PRODUCT_LEVEL}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.RECALL_LEVEL]:
    yup.mixed()
      .when(`${formFields.RECALL_LEVEL}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.BLOCK_LEVEL]:
    yup.mixed()
      .when(`${formFields.BLOCK_LEVEL}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.REASON]:
    yup.mixed()
      .when(`${formFields.REASON}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.RECALL_REASON]:
    yup.string().max(1000)
      .when(`${formFields.RECALL_REASON}_Required`, { is: true, then: yup.string().max(1000).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.SN]:
    yup.string().max(20)
      .when(`${formFields.SN}_Required`, { is: true, then: yup.string().max(20).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.BN]:
    yup.string().max(20)
      .when(`${formFields.BN}_Required`, { is: true, then: yup.string().max(20).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.NEW_BN]:
    yup.string().max(20)
      .when(`${formFields.NEW_BN}_Required`, { is: true, then: yup.string().max(20).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.CONTENT]:
    yup.string().max(2000)
      .when(`${formFields.CONTENT}_Required`, { is: true, then: yup.string().max(2000).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.CONTENT_S]:
    yup.string().max(2000)
      .when(`${formFields.CONTENT_S}_Required`, { is: true, then: yup.string().max(2000).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.TITLE]:
    yup.string().max(150)
      .when(`${formFields.TITLE}_max250`, { is: true, then: yup.string().max(250, i18n.t('ERR.250max')) })
      .when(`${formFields.TITLE}_Required`, { is: true, then: yup.string().max(150).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.TITLE_S]:
    yup.string().max(150)
      .when(`${formFields.TITLE_S}_Required`, { is: true, then: yup.string().max(150).required(i18n.t('ERR.fieldRequired')) }),
    // ----------------------------------
    [formFields.TYPE]:
    yup.mixed()
      .when(`${formFields.TYPE}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.STAKEHOLDER_USERNAME]:
    yup.mixed()
      .when(`${formFields.STAKEHOLDER_USERNAME}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.DESCRIPTION]:
    yup.string().max(2000)
      .when(`${formFields.DESCRIPTION}_max250`, { is: true, then: yup.string().max(300) })
      .when(`${formFields.DESCRIPTION}_max150`, { is: true, then: yup.string().max(150) })
      .when(`${formFields.DESCRIPTION}_Required`, { is: true, then: yup.string().nullable()
        .required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.SHORTAGE_TYPE]:
    yup.mixed()
      .when(`${formFields.SHORTAGE_TYPE}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.SHORTAGE_REASON]:
    yup.mixed()
      .when(`${formFields.SHORTAGE_REASON}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.STATUS]:
    yup.mixed()
      .when(`${formFields.STATUS}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    [formFields.AVAILABLE_QUANTITY]: yup
      .number()
      .max(99999999, i18n.t('ERR.limitExceeded'))
      .when(`${formFields.AVAILABLE_QUANTITY}_Required`, { is: true, then: yup.number().max(99999999, i18n.t('ERR.limitExceeded')).nullable()
        .required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.DISTRIBUTED_QUANTITY]: yup
      .number()
      .max(99999999, i18n.t('ERR.limitExceeded'))
      .nullable()
      .when(`${formFields.DISTRIBUTED_QUANTITY}_Required`, { is: true, then: yup.number().max(99999999, i18n.t('ERR.limitExceeded')).nullable()
        .required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.BENEFICIARY_PARTIES]: yup
      .string().max(1000)
      .nullable()
      .when(`${formFields.BENEFICIARY_PARTIES}_Required`, { is: true, then: yup.string().nullable().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.SHIPMENT_QUANTITY]: yup
      .number()
      .max(99999999, i18n.t('ERR.limitExceeded'))
      .when(`${formFields.SHIPMENT_QUANTITY}_Required`, { is: true, then: yup.number().max(99999999, i18n.t('ERR.limitExceeded')).required(i18n.t('ERR.fieldRequired')) }),
    [formFields.MARKET_DEMAND]:
    yup.mixed()
      .when(`${formFields.MARKET_DEMAND}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.EXPECTED_DATE]: yup
      .string()
      .when(`${formFields.EXPECTED_DATE}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.SHORTAGE_TYPE_OTHER]: yup
      .string().nullable().max(100)
      .when(`${formFields.SHORTAGE_TYPE_OTHER}_Required`, { is: true, then: yup.string().nullable().max(100)
        .required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.SHORTAGE_REASON_OTHER]: yup
      .string().nullable().max(100)
      .when(`${formFields.SHORTAGE_REASON_OTHER}_Required`, { is: true, then: yup.string().nullable().max(100)
        .required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.APPROVAL_STATUS]: yup
      .mixed()
      .when(`${formFields.APPROVAL_STATUS}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.APPROVAL_DATE]: yup
      .string()
      .when(`${formFields.APPROVAL_DATE}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.PARTIAL]: yup
      .mixed()
      .when(`${formFields.PARTIAL}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.ALTERNATIVE]: yup
      .mixed()
      .when(`${formFields.ALTERNATIVE}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.ALTERNATIF]: yup
      .mixed()
      .when(`${formFields.ALTERNATIF}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.CONTACTED_BEFORE]: yup
      .mixed()
      .when(`${formFields.CONTACTED_BEFORE}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.QUANTITY]: yup
      .number().max(2099999999).typeError(i18n.t('ERR.wrongValueType'))
      .when(`${formFields.QUANTITY}_Required`, { is: true, then: yup.number().max(2099999999).typeError(i18n.t('ERR.wrongValueType'))
        .required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.FILE]: yup
      .mixed()
      .when(`${formFields.FILE}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.REGESTER_NUMBER]: yup
      .number()
      .when(`${formFields.REGESTER_NUMBER}_Required`, { is: true, then: yup.number().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.PRODUCT_LIST]: yup
      .array()
      .when(`${formFields.PRODUCT_LIST}_Required`, { is: true, then: yup.array().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.COUNTRY]: yup
      .mixed()
      .when(`${formFields.COUNTRY}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.COUNTRY]: yup
      .mixed()
      .when(`${formFields.COUNTRY}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.DEACTIVATION_REASEON]: yup
      .mixed()
      .when(`${formFields.DEACTIVATION_REASEON}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.EXPLANATION]: yup
      .mixed()
      .when(`${formFields.EXPLANATION}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.TRADE_NAME]: yup
      .string().max(400)
      .when(`${formFields.TRADE_NAME}_Required`, { is: true, then: yup.string().max(400).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.TRADE_NAME_AR]: yup
      .string().nullable().max(400)
      .when(`${formFields.TRADE_NAME_AR}_Required`, { is: true, then: yup.string().nullable().max(400)
        .required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.ATC_CODE_1]: yup
      .string().nullable().max(50)
      .when(`${formFields.ATC_CODE_1}_Required`, { is: true, then: yup.string().nullable().max(50)
        .required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.ATC_CODE_2]: yup
      .string().nullable().max(50)
      .when(`${formFields.ATC_CODE_2}_Required`, { is: true, then: yup.string().nullable().max(50)
        .required(i18n.t('ERR.fieldRequired')) }),

    // -----------------------------------
    [formFields.MANUFACTURER_COUNTRY]: yup
      .mixed()
      .when(`${formFields.MANUFACTURER_COUNTRY}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.OPERATION]: yup
      .mixed()
      .when(`${formFields.OPERATION}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.DOSAGE_FORM]: yup
      .string().max(50)
      .when(`${formFields.DOSAGE_FORM}_Required`, { is: true, then: yup.string().max(50).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.MANUFACTURER_NAME]: yup
      .string().max(250)
      .when(`${formFields.MANUFACTURER_NAME}_Required`, { is: true, then: yup.string().max(250).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.PRICE]: yup
      .number().max(99999)
      .when(`${formFields.PRICE}_Required`, { is: true, then: yup.number().max(99999).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.MARKETING_COMPANY_COUNTRY]: yup
      .mixed()
      .when(`${formFields.MARKETING_COMPANY_COUNTRY}_Required`, {
        is: true,
        then: yup.mixed().test(
          'required',
          i18n.t('ERR.fieldRequired'),
          value => value !== undefined && value !== null && value !== ''
        )
      }),
    // -----------------------------------
    [formFields.MARKETING_COMPANY]: yup
      .string().max(250)
      .when(`${formFields.MARKETING_COMPANY}_Required`, { is: true, then: yup.string().max(250).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.STRENGHT_VALUE]: yup
      .string().max(50)
      .when(`${formFields.STRENGHT_VALUE}_Required`, { is: true, then: yup.string().max(50).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.VOLUME]: yup
      .number().max(2099999999, i18n.t('ERR.maxVolume')).test('is-decimal', i18n.t('ERR.decimalFormat'), value => (value ? (`${value}`).match(/^\d+(?:\.\d{1,2})?$/) : true))
      .when(`${formFields.VOLUME}_Required`, { is: true, then: yup.number().max(2099999999, i18n.t('ERR.maxVolume')).test('is-decimal', i18n.t('ERR.decimalFormat'), value => (value ? (`${value}`).match(/^\d+(?:\.\d{1,2})?$/) : true))
        .required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.PACKAGE_SIZE]: yup
      .number()
      .max(999)
      .when(`${formFields.PACKAGE_SIZE}_Required`, { is: true, then: yup.number().max(999).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.PACKAGE_TYPE]: yup
      .string().max(50)
      .when(`${formFields.PACKAGE_TYPE}_Required`, { is: true, then: yup.string().max(50).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.ROUTE_OF_ADMINISTRATION]: yup
      .string().max(100)
      .when(`${formFields.ROUTE_OF_ADMINISTRATION}_Required`, { is: true, then: yup.string().max(100).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.SHELF_LIFE]: yup
      .number()
      .max(999)
      .when(`${formFields.SHELF_LIFE}_Required`, {
        is: true, then: yup.number()
          .max(999).required(i18n.t('ERR.fieldRequired'))
      }),
    // -----------------------------------
    [formFields.STORAGE_CONDITION]: yup
      .mixed()
      .when(`${formFields.STORAGE_CONDITION}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.SERVICE_PRIVILEGE]: yup
      .array()
      .when(`${formFields.SERVICE_PRIVILEGE}_Required`, { is: true, then: yup.array().min(1, i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.DOMAINS]: yup
      .array()
      .when(`${formFields.DOMAINS}_Required`, { is: true, then: yup.array().min(1, i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.ALTERNATIVE_DRUG_ID]: yup
      .number()
      .when(`${formFields.ALTERNATIVE_DRUG_ID}_Required`, { is: true, then: yup.number().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.DRUG_ID]: yup
      .mixed()
      .when(`${formFields.DRUG_ID}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.MINIMUM_STOCK_LEVEL]: yup
      .number().max(999)
      .when(`${formFields.ALTERNATIVE_DRUG_ID}_Required`, { is: true, then: yup.number().max(999).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.ESSENTIALITY_LEVEL]: yup
      .number().max(9)
      .when(`${formFields.ALTERNATIVE_DRUG_ID}_Required`, { is: true, then: yup.number().max(9).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.LIMIT_QUANTITY]: yup
      .number().max(2099999999).min(0)
      .integer()
      .when(`${formFields.LIMIT_QUANTITY}_Required`, {
        is: true, then: yup.number().max(2099999999).integer()
          .min(0)
          .required(i18n.t('ERR.fieldRequired'))
      }),
    // -----------------------------------
    [formFields.REQUIRED_ACTION_ID]: yup.number()
      .when(`${formFields.REQUIRED_ACTION_ID}_Required`, { is: true, then: yup.number().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.REASON_ID]: yup.number()
      .when(`${formFields.REASON_ID}_Required`, { is: true, then: yup.number().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.MATCH_PERCENTAGE_FROM]: yup
      .number().min(0).max(100)
      .when(`${formFields.MATCH_PERCENTAGE_FROM}_Required`, {
        is: true, then: yup.number().min(0).max(100)
          .required(i18n.t('ERR.fieldRequired'))
      }),
    // -----------------------------------
    [formFields.MATCH_PERCENTAGE_TO]: yup
      .number().min(0).max(100)
      .when(`${formFields.MATCH_PERCENTAGE_TO}_Required`, {
        is: true, then: yup.number().min(0).max(100)
          .required(i18n.t('ERR.fieldRequired'))
      }),
    // -----------------------------------
    [formFields.CURRENT_QUANTITY]: yup.number().min(0).max(2099999999)
      .when(`${formFields.CURRENT_QUANTITY}_Required`, { is: true, then: yup.number().max(2099999999).min(0)
        .required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.NEEDED_QUANTITY]: yup.number().min(1).max(2099999999)
      .when(`${formFields.NEEDED_QUANTITY}_Required`, { is: true, then: yup.number().max(2099999999).min(1)
        .required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.USED_QUANTITY]: yup.number().min(0).max(2099999999)
      .when(`${formFields.USED_QUANTITY}_Required`, { is: true, then: yup.number().max(2099999999).min(0)
        .required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.DEMAND_ID]: yup
      .string()
      .when(`${formFields.DEMAND_ID}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.DELIVERY_DATE]: yup
      .string()
      .when(`${formFields.DELIVERY_DATE}_Required`, {
        is: true, then: yup.string()
          .required(i18n.t('ERR.fieldRequired'))
      }),
    // -----------------------------------
    [formFields.SFDA_REPLY]: yup
      .string()
      .when(`${formFields.SFDA_REPLY}_Required`, {
        is: true, then: yup.string()
          .required(i18n.t('ERR.fieldRequired'))
      }),
    [formFields.OTP]: yup
      .string().test('is-OTP', i18n.t('ERR.notOTP'), value => (value ? (`${value}`).match(/^\d{6}$/) : true))
      .when(`${formFields.OTP}_Required`, {
        is: true, then: yup.string().test('is-OTP', i18n.t('ERR.notOTP'), value => (value ? (`${value}`).match(/^\d{6}$/) : true))
          .required(i18n.t('ERR.fieldRequired'))
      }),
    // -----------------------------------
    [formFields.TRANSACTION_ID]: yup.string().max(20)
      .when(`${formFields.TRANSACTION_ID}_Required`, { is: true, then: yup.string().max(20).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.SUBSCRIPTION_TYPE]: yup
      .mixed()
      .when(`${formFields.SUBSCRIPTION_TYPE}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.SUBSCRIPTION_PACKAGE]: yup
      .mixed()
      .when(`${formFields.SUBSCRIPTION_PACKAGE}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.NOTE]: yup
      .string()
      .max(1000)
      .when(`${formFields.NOTE}_Required`, { is: true, then: yup.string().max(1000).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.NOTIFICATION_ID]: yup
      .number()
      .test('is-20-digits', i18n.t('ERR.notificationIdLength'), value => {
        if (!value) { return true; } // Allow empty if not required
        const stringValue = String(value);

        return stringValue.length <= 19 && (/^\d+$/).test(stringValue);
      })
      .when(`${formFields.NOTIFICATION_ID}_Required`, {
        is: true,
        then: yup.number()
          .test('is-20-digits', i18n.t('ERR.notificationIdLength'), value => {
            if (!value) { return false; } // Required field must have value
            const stringValue = String(value);

            return stringValue.length <= 19 && (/^\d+$/).test(stringValue);
          })
          .required(i18n.t('ERR.notificationIdLength'))
      }),
    // -----------------------------------
    [formFields.ID]: yup
      .number()
      .max(2099999999)
      .when(`${formFields.ID}_Required`, { is: true, then: yup.number().max(2099999999).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.REQUEST_ID]: yup
      .number()
      .max(2099999999)
      .when(`${formFields.REQUEST_ID}_Required`, { is: true, then: yup.number().max(2099999999).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.REMARK]: yup
      .string()
      .max(1000).nullable()
      .when(`${formFields.REMARK}_Required`, { is: true, then: yup.string().max(1000).nullable()
        .required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.GTIN_OR_DRUG_NAME]: yup
      .number()
      .nullable()
      .when(`${formFields.GTIN_OR_DRUG_NAME}_Required`, { is: true, then: yup.number().nullable()
        .required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.COMPANY_ID]: yup
      .string()
      .when(`${formFields.COMPANY_ID}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.IMPORT_REQUEST_NUMBER]: yup
      .string()
      .when(`${formFields.IMPORT_REQUEST_NUMBER}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.IMPORTED_QUANTITY]: yup
      .number()
      .typeError('Not a number')
      .max(99999999, i18n.t('ERR.limitExceeded'))
      .when(`${formFields.IMPORTED_QUANTITY}_Required`, { is: true, then: yup.number().typeError('Not a number')
        .required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.COUNTRY_OF_MANUFACTURER]: yup
      .string()
      .when(`${formFields.COUNTRY_OF_MANUFACTURER}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.UNIT_OF_VOLUME]: yup
      .string()
      .when(`${formFields.UNIT_OF_VOLUME}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.STRENGHT_VALUE_UNIT]: yup
      .string()
      .when(`${formFields.STRENGHT_VALUE_UNIT}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.FILES]: yup
      .mixed()
      .when(`${formFields.FILES}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.FASEH_CERTIFICATE]: yup
      .mixed()
      .when(`${formFields.FASEH_CERTIFICATE}_Required`, { is: true, then: yup.mixed().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.LABEL_NAME]: yup
      .string()
      .max(50)
      .nullable()
      .when(`${formFields.LABEL_NAME}_Required`, { is: true, then: yup.string().max(50).nullable()
        .required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.LABEL_LEVEL]: yup
      .string()
      .when(`${formFields.LABEL_LEVEL}_Required`, { is: true, then: yup.string().required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.TO_GLN]: yup
      .string()
      .matches(/^\d{13}$/, i18n.t('ERR.gln'))
      .when(`${formFields.TO_GLN}_Required`, { is: true, then: yup.string().matches(/^\d{13}$/, i18n.t('ERR.gln')).required(i18n.t('ERR.fieldRequired')) }),
    // -----------------------------------
    [formFields.STOCK_MATCH_QUANTITY]: yup
      .number()
      .typeError(i18n.t('ERR.notNumber'))
      .when(`${formFields.STOCK_MATCH_QUANTITY}_Required`, { is: true, then: yup.number().typeError(i18n.t('ERR.notNumber'))
        .required(i18n.t('ERR.fieldRequired')) })

    // ---------------Template--------------------
    // [formFields.]: yup
    //  .()
    //  .when(`${formFields.}_Required`, { is: true, then: yup.().required(i18n.t('ERR.fieldRequired')) }),

  };

export const createYupSchema = (schema, config) => {
  const { id, validationType, validations = [] } = config;
  if (!yup[validationType]) {
    return schema;
  }
  let validator = yup[validationType]();
  validations.forEach(validation => {
    const { params, type } = validation;
    if (!validator[type]) {
      return;
    }
    validator = validator[type](...params);
  });
  schema[id] = validator;

  return schema;
};

export const generateSchema = (fileds, extraSchema = {}) => {
  const subShape = Object.keys(fildsSpecifications).map(key => [ key, fildsSpecifications[key] ]).filter(i => fileds.includes(i[0]))
    .reduce((p, c) => {
      p[c[0]] = c[1];

      return p;
    }, {});

  yup.setLocale({
    mixed: {
      notType: function notType(_ref) {
        switch (_ref.type) {
          case 'number':
            return 'Not a number';
          case 'string':
            return 'Not a string';
          default:
            return 'Wrong type';
        }
      }
    }
  });

  return yup.object().shape({ ...subShape, ...extraSchema });
};
